module.exports = __webpack_public_path__ + "static/img/logo.b24f2d08.png";